import { render, staticRenderFns } from "./CreateTemplateFromProject.vue?vue&type=template&id=647d0913&"
import script from "./CreateTemplateFromProject.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateFromProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports